export const DATE_FORMAT = 'yyyy-MM-dd'
export const MONTH_FORMAT = 'yyyy-MM'
export const TIME_FORMAT = 'HH:mm:ss'
export const MINUTE_FORMAT = 'HH:mm'
export const FORTUNE_DATE_FORMAT_TO_SECONDS = 'yyyy-MM-dd HH:mm:ss'
export const FORTUNE_DATE_FORMAT_TO_MINUTES = 'yyyy/MM/dd HH:mm'
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`
/** 到分鐘、dash 分隔（figma 點數兌換系列採此格式；slash 版見 FORTUNE_DATE_FORMAT_TO_MINUTES） */
export const DATE_TIME_FORMAT_TO_MINUTES = `${DATE_FORMAT} ${MINUTE_FORMAT}`
/** 檔名時間戳：無分隔、到秒（例：20260624153000） */
export const FILE_TIMESTAMP_FORMAT = 'yyyyMMddHHmmss'
export const SUNDAY = 0
export const SATURDAY = 6
